import { useMemo } from "react";
import { useOpenDocWidget } from "@SeemplicityDev/shared";
import { openFreshchat } from "../ThirdPartyProviders/ThirdPartyProviders";
import type { AppSettingsMenuItem } from "./appSettingsMenuItem";

const DOCUMENTATION_SITE_LINK = "https://docs.seemplicity.io/";

const useHelpMenuItems = (): AppSettingsMenuItem[] => {
  const { openWidget } = useOpenDocWidget();

  return useMemo<AppSettingsMenuItem[]>(() => {
    return [
      {
        text: "Help Panel",
        onClick: () => {
          openWidget();
        },
        "data-analytics-event": "user_click",
        "data-analytics-props": `{"name": "help_panel", "container": "app_header_documentation_menu"}`,
      },
      {
        text: "Knowledge Base",
        onClick: () => {
          window.open(DOCUMENTATION_SITE_LINK, "_blank");
        },
      },
      {
        text: "Chat Support",
        onClick: openFreshchat,
      },
    ];
  }, [openWidget]);
};

export default useHelpMenuItems;
